import { FunctionComponent } from 'react';

import { Button } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useContainer } from 'unstated-next';

import BreakoutRoomCreatorInitialSetup from './BreakoutRoomCreatorInitialSetup';
import BreakoutRoomRowCollection from './BreakoutRoomRowCollection';
import BreakoutRoomOptionsContainer from '../BreakoutRoomOptionsContainer';
import { BreakoutCreateMode } from '../enums/BreakoutCreateMode';
import { StyledBottomRowContainer, StyledPanelContainer, LayoutContainer } from '../styles/styled-components';

const BreakoutRoomCreatorOptionsBody: FunctionComponent = () => {
    const { t } = useTranslation('breakout_room');
    const {
        createMode,
        handleCancel,
        handleCreate,
        handleOpenRooms,
        handleCloseRooms,
        roomsOpen,
        handleRecreateRooms,
        handleAddRoom
    } = useContainer(BreakoutRoomOptionsContainer);

    const renderBody = () => {
        switch (createMode) {
            default:
            case BreakoutCreateMode.InitialSetup:
                return <BreakoutRoomCreatorInitialSetup />;
            case BreakoutCreateMode.AssignAuto:
                return <BreakoutRoomRowCollection />;
            case BreakoutCreateMode.AssignManual:
            case BreakoutCreateMode.AllowChoice:
                return <BreakoutRoomRowCollection />;
        }
    };

    const renderManagementButtons = () => {
        const initialSetup = createMode === BreakoutCreateMode.InitialSetup;
        const roomsCreated = createMode !== BreakoutCreateMode.InitialSetup && !roomsOpen;
        const roomsOpened = createMode !== BreakoutCreateMode.InitialSetup && roomsOpen;
        return (
            <>
                <StyledBottomRowContainer>
                    {!roomsOpened && (
                        <Button variant="outlined" onClick={handleCancel} style={{ margin: 10 }}>
                            {t('cancel')}
                        </Button>
                    )}
                    {initialSetup && (
                        <Button variant="contained" onClick={handleCreate} style={{ margin: 10 }}>
                            {t('create')}
                        </Button>
                    )}
                    {roomsCreated && (
                        <Button variant="outlined" onClick={handleRecreateRooms} style={{ margin: 10 }}>
                            {t('recreate')}
                        </Button>
                    )}
                    {roomsCreated && (
                        <Button variant="outlined" onClick={handleAddRoom} style={{ margin: 10 }}>
                            {t('add-room')}
                        </Button>
                    )}
                    {roomsCreated && (
                        <Button variant="contained" onClick={handleOpenRooms} style={{ margin: 10 }}>
                            {t('open-all-rooms')}
                        </Button>
                    )}
                    {roomsOpened && (
                        <Button
                            variant="contained"
                            onClick={handleCloseRooms}
                            style={{ backgroundColor: 'red', margin: 10 }}
                        >
                            {t('close-all-rooms')}
                        </Button>
                    )}
                </StyledBottomRowContainer>
            </>
        );
    };

    return (
        <LayoutContainer>
            <StyledPanelContainer>{renderBody()}</StyledPanelContainer>
            {renderManagementButtons()}
        </LayoutContainer>
    );
};

export default BreakoutRoomCreatorOptionsBody;
